// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2J44z","toggleWrap":"styles_toggleWrap__2HkqU","content":"styles_content__bhawE","selectAreaCode":"styles_selectAreaCode__2BEOu"};